import type { ShiftWithCalc } from '../types';

export type ShiftKind = 'vroeg' | 'laat' | 'nacht' | 'verlof' | 'ziek' | 'geruild';

/**
 * Soort dienst zoals een beveiliger erover praat: ochtend-, avond- of nachtdienst,
 * of een dag die anders liep (verlof, ziek, geruild).
 */
export function shiftKind(s: Pick<ShiftWithCalc, 'start_time' | 'end_time' | 'leave_type' | 'deviation_reason'>): ShiftKind {
  if (s.leave_type === 'ziekte' || s.deviation_reason === 'ziek') return 'ziek';
  if ((s.leave_type && s.leave_type !== 'work') || s.deviation_reason === 'verlof') return 'verlof';
  if (s.deviation_reason === 'geruild') return 'geruild';
  const start = Number(s.start_time.slice(0, 2));
  const crosses = s.end_time <= s.start_time;
  if (crosses || start >= 21 || start < 5) return 'nacht';
  if (start >= 12) return 'laat';
  return 'vroeg';
}

export const KIND_LABEL: Record<ShiftKind, string> = {
  vroeg: 'Ochtend',
  laat: 'Avond',
  nacht: 'Nacht',
  verlof: 'Verlof',
  ziek: 'Ziek',
  geruild: 'Geruild',
};

/** Rand (links), vlak en tekst per soort. Kleur is nooit de enige drager: het label staat er ook. */
export const KIND_STYLE: Record<ShiftKind, { bar: string; bg: string; text: string; dot: string }> = {
  vroeg: { bar: 'border-l-sky-400', bg: 'bg-sky-400/10', text: 'text-sky-100', dot: 'bg-sky-400' },
  laat: { bar: 'border-l-orange-400', bg: 'bg-orange-400/10', text: 'text-orange-100', dot: 'bg-orange-400' },
  nacht: { bar: 'border-l-indigo-400', bg: 'bg-indigo-400/15', text: 'text-indigo-100', dot: 'bg-indigo-400' },
  verlof: { bar: 'border-l-emerald-400', bg: 'bg-emerald-400/10', text: 'text-emerald-100', dot: 'bg-emerald-400' },
  ziek: { bar: 'border-l-rose-400', bg: 'bg-rose-400/10', text: 'text-rose-100', dot: 'bg-rose-400' },
  geruild: { bar: 'border-l-slate-500', bg: 'bg-slate-500/10', text: 'text-slate-400 line-through', dot: 'bg-slate-500' },
};
